import { render, staticRenderFns } from "./CourseTest.vue?vue&type=template&id=5fc41119&scoped=true&"
import script from "./CourseTest.vue?vue&type=script&lang=js&"
export * from "./CourseTest.vue?vue&type=script&lang=js&"
import style0 from "./CourseTest.vue?vue&type=style&index=0&id=5fc41119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc41119",
  null
  
)

export default component.exports